// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"style_checkboxContainer__7VfyCRsBOsKPPYaTEDFNF","checkbox":"style_checkbox__3T2Mkbo_m2Hwr628pZb4Py","checkboxIcon":"style_checkboxIcon__1-JeUZHetkptbZamDbPHDy"};